/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SandboxIcon = ({ width = 24, height = 24, hidden = false, title = 'Sandbox' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect x="2" y="2" width="14" height="30" rx="1" />
    <path d="M24 2h2v2h-2z" />
    <path d="M24 2h2v2h-2zM28 2h2v2h-2z" />
    <path d="M28 2h2v2h-2zM34 4V3a1 1 0 0 0-1-1h-1v2Z" />
    <path d="M34 4V3a1 1 0 0 0-1-1h-1v2ZM22 4V2h-1a1 1 0 0 0-1 1v1ZM20 6h2v2h-2z" />
    <path d="M20 6h2v2h-2zM20 10h2v2h-2z" />
    <path d="M20 10h2v2h-2zM20 14h2v2h-2z" />
    <path d="M20 14h2v2h-2zM20 18h2v2h-2z" />
    <path d="M20 18h2v2h-2zM20 22h2v2h-2z" />
    <path d="M20 22h2v2h-2zM20 26h2v2h-2z" />
    <path d="M20 26h2v2h-2zM22 32v-2h-2v1a1 1 0 0 0 1 1Z" />
    <path d="M22 32v-2h-2v1a1 1 0 0 0 1 1ZM24 30h2v2h-2z" />
    <path d="M24 30h2v2h-2zM28 30h2v2h-2z" />
    <path d="M28 30h2v2h-2zM32 6h2v2h-2z" />
    <path d="M32 6h2v2h-2zM32 10h2v2h-2z" />
    <path d="M32 10h2v2h-2zM32 14h2v2h-2z" />
    <path d="M32 14h2v2h-2zM32 18h2v2h-2z" />
    <path d="M32 18h2v2h-2zM32 22h2v2h-2z" />
    <path d="M32 22h2v2h-2zM32 26h2v2h-2z" />
    <path d="M32 26h2v2h-2zM34 31v-1h-2v2h1a1 1 0 0 0 1-1Z" />
    <path d="M34 31v-1h-2v2h1a1 1 0 0 0 1-1Z" />
  </svg>`;
};
